import React, { useEffect, useState } from 'react'
import { SelectionScreen } from './SelectionScreen'
import { getPromotionValue } from 'shared/utils/ecommerce'
import { eCommerceMetadata, eventMetadata } from 'shared/store/metadata'
import { useSelector, useDispatch } from 'react-redux'
import { breakpoints, style } from 'app/assets/styles'
import type { RootState } from 'shared/store/reducers'
import { getProductById } from 'shared/store/ecommerce/catalog'
import { setCurrentItemInfos } from 'shared/store/ecommerce/order'
import Modal from 'react-modal'
import type {
    Coupon,
    SelectionScreenInfos,
    ClickAndCollectPromotion
} from 'shared/types'
const { classicModalMobileStyle, classicModalStyle } = style

type SelectionScreenModalProps = {
    selectionScreenInfos: ?SelectionScreenInfos,
    displaySelectionScreen: boolean,
    selectedCoupon: ?Coupon,
    handleClose?: () => void
}

export const SelectionScreenModal = ({
    selectionScreenInfos,
    displaySelectionScreen,
    selectedCoupon,
    handleClose
}: SelectionScreenModalProps) => {
    const [displayModal, setDisplayModal] = useState(displaySelectionScreen)

    useEffect(() => {
        setDisplayModal(displaySelectionScreen)
    }, [displaySelectionScreen])

    const product = useSelector((s: RootState) => {
        const idReboot = selectionScreenInfos?.promotion?.idReboot
        if (idReboot) {
            return getProductById(s.ecommerceCatalogState, idReboot)
        }
        return undefined
    })

    const d = useDispatch()

    return (
        <Modal
            isOpen={!!selectionScreenInfos}
            onRequestClose={() => setDisplayModal(false)}
            style={
                window.innerWidth < breakpoints.medium
                    ? classicModalMobileStyle
                    : classicModalStyle
            }>
            <SelectionScreen
                selectionScreenInfos={selectionScreenInfos}
                handleClose={() => {
                    setDisplayModal(false)
                    !!handleClose && handleClose()
                }}
                setCurrentItemInfos={data => d(setCurrentItemInfos(data))}
            />
        </Modal>
    )
}
